import { render, staticRenderFns } from "./TagOptions.vue?vue&type=template&id=42b64f4b&scoped=true"
import script from "./TagOptions.vue?vue&type=script&lang=js"
export * from "./TagOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b64f4b",
  null
  
)

export default component.exports